import {
  JsonapiEntity,
  attribute,
  entity,
  relationship,
} from 'jsonapi-transformers';

import { ListItem } from '®shared/reading-list';

@entity({ type: 'broken_link_reports' })
export class BrokenLinkReport extends JsonapiEntity<BrokenLinkReport> {
  @attribute() details: string | null;
  @relationship() item: ListItem;
  @attribute() reporter_email: string | null;
  @attribute() screen_resolution: string | null;
  @attribute() user_agent: string | null;
}
